import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Support icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Support } from '@sravni/design-system-icons'
 *
 * <Support />
 * ```
 */
var Support = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Support", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#Support__a)", stroke: "currentColor" },
        React.createElement("path", { d: "M10.736 17.5c3.866 0 7-3.07 7-6.857V8.357c0-3.787-3.134-6.857-7-6.857s-7 3.07-7 6.857v3.429", strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("circle", { cx: "10.736", cy: "17.5", r: "1" }),
        React.createElement("path", { d: "M10.736 14.5c-2.209 0-4-2.203-4-4.302V8.3c0-2.098 1.791-3.799 4-3.799 2.21 0 4 1.7 4 3.799v1.9c0 2.098-1.79 4.301-4 4.301Z", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M1.736 9.5a1 1 0 0 1 1-1h1v4h-1a1 1 0 0 1-1-1v-2ZM19.736 9.5a1 1 0 0 0-1-1h-1v4h1a1 1 0 0 0 1-1v-2Z", strokeWidth: "1.5", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "Support__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736)", d: "M0 0h20v20H0z" }))))); });

export { Support };
//# sourceMappingURL=Support.js.map
